<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/agro_exporter/finances/query_container_outcomes/show_process.yml"
  lang="yaml"
></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('list_processes')"
    :params="{ agro_exporter_id: agro_exporter_id }"
  >
  </go-back-link>

  <bread-crumbs
    :labels="[
      module_name,
      agro_exporter_process.name,
    ]"
  />

  <template v-if="load_data_general">
    <tabs-container v-model="option_tabs" :with_routing="true" />

    <router-view
      :containers="containers"
      :org_invoices="org_invoices"
    ></router-view>
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/finances/query_container_outcomes/show_process.js";

export default {
  name: "OrgFinancesQueryContainerIncomesShowProcess",
  props: {
    agro_exporter_process_id: { required: true },
    agro_exporter_id: { required: true },
  },
  data() {
    return {
      load_data_general: false,
      option_tabs: [],
      agro_exporter_process: {},
      containers: [],
      org_invoices: [],
    };
  },
  methods: {
    loadData: async function () {
      await this.fetchAgroExporterProcess();
      await this.fetchContainers();
      await this.fetchOrgInvoices();
      this.fillTabOPtions();
      this.load_data_general = true;
    },
    fetchAgroExporterProcess: async function () {
      let response = await Requester.fetchAgroExporterProcess(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.agro_exporter_process = response.data;
    },
    fetchContainers: async function () {
      let response = await Requester.fetchContainers(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.containers = response.data;
    },
    fetchOrgInvoices: async function () {
      let response = await Requester.fetchOrgInvoices(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.org_invoices = response.data;
    },
    fillTabOPtions: function () {
      this.option_tabs = [
        {
          name: this.$t("labels.containers_title"),
          icon: "fa-solid fa-container-storage",
          route: { name: this.routeName("show_process_containers") },
        },
        {
          name: this.$t("labels.org_invoices_title"),
          icon: "fa-solid fa-file-invoice-dollar",
          route: { name: this.routeName("show_process_org_invoices") },
        },
      ];
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id,
        },
      }).then(() => this.loadData())
    );
  },
};
</script>
